/**
 * Formata um número para o formato de moeda brasileira
 * Ex: 1234.56 -> "1.234,56"
 */
export function formatCurrency(value: number): string {
  return value.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/**
 * Formata quantidade de papéis. Inteiro sai sem casas ("306"); fracionário
 * sai com até duas ("109,09"). O limite também absorve o resíduo de ponto
 * flutuante que aparece ao somar compras do Tesouro — 109,08999999999999.
 */
export function formatQuantity(value: number): string {
  return value.toLocaleString('pt-BR', { maximumFractionDigits: 2 });
}
